import EventEmitter from 'eventemitter3';

// Single shared emitter instance
const eventBus = new EventEmitter();

export default eventBus;
